import { isClient } from './../utils/process';

export default (context, inject) => {
  // @todo: remove when clients are migrated to SPA's
  inject('isClient', isClient);

  inject('getEnv', (envParam, fallback = null) => {
    if (context.$config[envParam]) {
      return context.$config[envParam];
    }

    if (isClient() && window[envParam] !== undefined) {
      return window[envParam];
    }

    return fallback;
  });
};
